export default "__VITE_ASSET__C$MDSLpd__"